import { GeoPoint } from 'firebase/firestore'
import { firestoreTimestampToDate, isDate } from '../utils/obejct-diff'
import { Context, ContextMembership } from './context.data'
import { NetworkConstants } from './network.constants'

export const DefaultIconsPoiMapping = new Map([
    ["boar", "icnSchwarzwild"],

    ["bolt.fill", "icon-bolt"],
        ["geoobjekt/bolt.fill", "icon-bolt"],
        ["geoobjekt_bolt.fill", "icon-bolt"],
    ["doc.text.magnifyingglass","icon_doc-text_search"],
        ["geoobjekt/doc.text.magnifyingglass","icon_doc-text_search"],
        ["geoobjekt_doc.text.magnifyingglass","icon_doc-text_search"],
    ["drueckjagdbock", 'diwima_smp_drueckjagdbock_al'],
        ["geoobjekt/drueckjagdbock","diwima_smp_drueckjagdbock_al"],
        ["geoobjekt_drueckjagdbock","diwima_smp_drueckjagdbock_al"],
    ["drückjagdbock", 'diwima_smp_drueckjagdbock_al'],
        ["geoobjekt/drückjagdbock","diwima_smp_drueckjagdbock_al"],
        ["geoobjekt_drückjagdbock","diwima_smp_drueckjagdbock_al"],
    ["drueckjagdstand", 'diwima_smp_drueckjagdbock_al'],
        ["geoobjekt/drueckjagdstand", 'diwima_smp_drueckjagdbock_al'],
        ["geoobjekt_drueckjagdstand", 'diwima_smp_drueckjagdbock_al'],
    ["drückjagdstand","diwima_smp_drueckjagdbock_al"],
        ["geoobjekt/drückjagdstand","diwima_smp_drueckjagdbock_al"],
        ["geoobjekt_drückjagdstand","diwima_smp_drueckjagdbock_al"],
    ["erdsitz", 'diwima_smp_erdsitz-maj'],
        ["geoobjekt/erdsitz", 'diwima_smp_erdsitz-maj'],
        ["geoobjekt_erdsitz", 'diwima_smp_erdsitz-maj'],
    ["flache-gewaesser","icon_flache-gewaesser"],
        ["geoobjekt/flache-gewaesser","icon_flache-gewaesser"],
        ["geoobjekt_flache-gewaesser","icon_flache-gewaesser"],
    ["hochsitz", 'diwima_smp_hochsitz-maj'],
        ["geoobjekt/hochsitz", 'diwima_smp_hochsitz-maj'],
        ["geoobjekt_hochsitz", 'diwima_smp_hochsitz-maj'],
    ["house.circle.fill","icon_house_circle_fill"],
        ["geoobjekt/house.circle.fill","icon_house_circle_fill"],
        ["geoobjekt_house.circle.fill","icon_house_circle_fill"],
    ["jagdhuette","diwima_smp_jagdhuette-maj"],
        ["geoobjekt/jagdhuette", "diwima_smp_jagdhuette-maj"],
        ["geoobjekt_jagdhuette", "diwima_smp_jagdhuette-maj"],
    ["Kadaver","diwima_ic_schwarzwild"],
        ["geoobjekt/Kadaver","diwima_ic_schwarzwild"],
        ["geoobjekt_Kadaver","diwima_ic_schwarzwild"],
    ["kanzel.geschlossen", 'diwima_smp_hochsitz-maj'],//5k
        ["geoobjekt/kanzel.geschlossen", 'diwima_smp_hochsitz-maj'],//5k
        ["geoobjekt_kanzel.geschlossen", 'diwima_smp_hochsitz-maj'],//5k
    ["kanzel (geschlossen)", 'diwima_smp_hochsitz-maj'],//5k
        ["geoobjekt/kanzel (geschlossen)", 'diwima_smp_hochsitz-maj'],//5k
        ["geoobjekt_kanzel (geschlossen)", 'diwima_smp_hochsitz-maj'],//5k
    ["kanzel.offen", 'diwima_smp_hochsitz-maj'],
        ["geoobjekt/kanzel.offen", 'diwima_smp_hochsitz-maj'],
        ["geoobjekt_kanzel.offen", 'diwima_smp_hochsitz-maj'],
    ["kanzel.schlafkanzel", 'diwima_smp_hochsitz-maj'],
        ["geoobjekt/kanzel.schlafkanzel", 'diwima_smp_hochsitz-maj'],
        ["geoobjekt_kanzel.schlafkanzel", 'diwima_smp_hochsitz-maj'],
    ["Kanzel (schlaf~)", 'diwima_smp_hochsitz-maj'],
        ["geoobjekt/Kanzel (schlaf~)", 'diwima_smp_hochsitz-maj'],
        ["geoobjekt_Kanzel (schlaf~)", 'diwima_smp_hochsitz-maj'],
    ["kirrung", 'diwima_smp_kirung-maj'],
        ["geoobjekt/kirrung", 'diwima_smp_kirung-maj'],
        ["geoobjekt/kirung", 'diwima_smp_kirung-maj'],
        ["geoobjekt_kirrung", 'diwima_smp_kirung-maj'],
    ["leiter.offen.baum", 'diwima_smp_leiter-baum-maj'],
        ["geoobjekt/leiter.offen.baum", 'diwima_smp_leiter-baum-maj'],
        ["geoobjekt_leiter.offen.baum", 'diwima_smp_leiter-baum-maj'],
    ["leiter-baum", 'diwima_smp_leiter-baum-maj'],
        ["geoobjekt/leiter-baum", 'diwima_smp_leiter-baum-maj'],
        ["geoobjekt_leiter-baum", 'diwima_smp_leiter-baum-maj'],
    ["leiter.offen.frei", 'diwima_smp_leiter-offen-maj'],
        ["geoobjekt/leiter.offen.frei", 'diwima_smp_leiter-offen-maj'],
        ["geoobjekt_leiter.offen.frei", 'diwima_smp_leiter-offen-maj'],
    ["leiter-offen", 'diwima_smp_leiter-offen-maj'],
        ["geoobjekt/leiter-offen", 'diwima_smp_leiter-offen-maj'],
        ["geoobjekt_leiter-offen", 'diwima_smp_leiter-offen-maj'],
    ["leiter (offen, freistehend)", 'diwima_smp_leiter-offen-maj'],
        ["geoobjekt/leiter (offen, freistehend)", 'diwima_smp_leiter-offen-maj'],
        ["geoobjekt_leiter (offen, freistehend)", 'diwima_smp_leiter-offen-maj'],
    ["location.magnifyingglass","icon_location_magnifyingglas"],
        ["geoobjekt/location.magnifyingglass","icon_location_magnifyingglas"],
        ["geoobjekt_location.magnifyingglass","icon_location_magnifyingglas"],
    ["maiskolben","icon_maiskolben"],
        ["geoobjekt/maiskolben","icon_maiskolben"],
        ["geoobjekt_maiskolben","icon_maiskolben"],
    ["parkplatz", "icon_parkplatz"],//+
        ["geoobjekt/parkplatz", "icon_parkplatz"],//+
        ["geoobjekt_parkplatz", "icon_parkplatz"],//+
    ["pin","icon-pin"],
        ["geoobjekt/pin","icon-pin"],
        ["geoobjekt_pin","icon-pin"],
    ["pirschweg", "icon_pirschweg"],//+
        ["geoobjekt/pirschweg", "icon_pirschweg"],//+
        ["geoobjekt_pirschweg", "icon_pirschweg"],//+
    ["fundort probe", "diwima_ic_probenbehaeltnisse"],
    ["Fundort Probe", "diwima_smp_reagenzglas_orange"],//
        ["geoobjekt/fundort probe", "diwima_ic_probenbehaeltnisse"],
        ["geoobjekt_fundort probe", "diwima_ic_probenbehaeltnisse"],
    ["powerplug.fill","icon_powerplug"],
        ["geoobjekt/powerplug.fill","icon_powerplug"],
        ["geoobjekt_powerplug.fill","icon_powerplug"],
    ["salzlecke", 'icon-salzlecke'],
        ["geoobjekt/salzlecke", 'icon-salzlecke'],
        ["geoobjekt_salzlecke", 'icon-salzlecke'],
    ["schoepfstelle","icon_schoepfstelle"],
        ["geoobjekt/schoepfstelle","icon_schoepfstelle"],
        ["geoobjekt_schoepfstelle","icon_schoepfstelle"],
    ["sammelplatz", "icon_sammelplatz"],
        ["geoobjekt/sammelplatz", "icon_sammelplatz"],
        ["geoobjekt_sammelplatz", "icon_sammelplatz"],
    ["selectedPoint","icon-pin"],
        ["geoobjekt/selectedPoint","icon-pin"],
        ["geoobjekt_selectedPoint","icon-pin"],
    ["suhle","icon_suhle"],
        ["geoobjekt/suhle","icon_suhle"],
        ["geoobjekt_suhle","icon_suhle"],
    ["tablecells","icon-table"],
        ["geoobjekt/tablecells","icon-table"],
        ["geoobjekt_tablecells","icon-table"],
    ["tor","icon_tor"],
        ["geoobjekt/tor","icon_tor"],
        ["geoobjekt_tor","icon_tor"],
    ["undefined","undefined"],
    
    ["wasserlitze","icon-wasserlitze"],
        ["geoobjekt/wasserlitze","icon-wasserlitze"],
        ["geoobjekt_wasserlitze","icon-wasserlitze"],
    ["wildkamera","icon-wildkamera"],
        ["geoobjekt/wildkamera","icon-wildkamera"],
        ["geoobjekt_wildkamera","icon-wildkamera"],
    ["wildkammer", 'diwima_smp_wildkammer-maj'],
        ["geoobjekt/wildkammer", 'diwima_smp_wildkammer-maj'],
        ["geoobjekt_wildkammer", 'diwima_smp_wildkammer-maj'],


])

export const DefaultIconSelect = new Map([
    // ["fundort probe", "diwima_smp_reagenzglas_orange"],
    // ["Fundort Probe", "diwima_smp_reagenzglas_orange"],
    // ["undefined","undefined"],
    ["bolt.fill", "icon-bolt"],
    ["doc.text.magnifyingglass","icon_doc-text_search"],
    ["drueckjagdbock", 'diwima_smp_drueckjagdbock_al'],
    // ["drückjagdbock", 'diwima_smp_drueckjagdbock_al'],
    // ["drueckjagdstand", 'diwima_smp_drueckjagdbock_al'],
    // ["drückjagdstand","diwima_smp_drueckjagdbock_al"],
    ["erdsitz", 'diwima_smp_erdsitz-maj'],
    ["flache-gewaesser","icon_flache-gewaesser"],
    ["hochsitz", 'diwima_smp_hochsitz-maj'],
    ["house.circle.fill","icon_house_circle_fill"],
    ["jagdhuette","diwima_smp_jagdhuette-maj"],
    // ["Kadaver","diwima_ic_schwarzwild"],
    // ["kanzel.geschlossen", 'diwima_smp_hochsitz-maj'],
    // ["kanzel (geschlossen)", 'diwima_smp_hochsitz-maj'],
    // ["kanzel.offen", 'diwima_smp_hochsitz-maj'],
    // ["kanzel.schlafkanzel", 'diwima_smp_hochsitz-maj'],
    // ["Kanzel (schlaf~)", 'diwima_smp_hochsitz-maj'],
    ["kirrung", 'diwima_smp_kirung-maj'],
    // ["leiter.offen.baum", 'diwima_smp_leiter-baum-maj'],
    ["leiter-baum", 'diwima_smp_leiter-baum-maj'],
    // ["leiter.offen.frei", 'diwima_smp_leiter-offen-maj'],
    ["leiter-offen", 'diwima_smp_leiter-offen-maj'],
    // ["leiter (offen, freistehend)", 'diwima_smp_leiter-offen-maj'],
    ["location.magnifyingglass","icon_location_magnifyingglas"],
    // ["maiskolben","icon_maiskolben"],
    ["parkplatz", "icon_parkplatz"],
    ["pin","icon-pin"],
    ["pirschweg", "icon_pirschweg"],
    // ["fundort probe", "diwima_ic_probenbehaeltnisse"],
    ["powerplug.fill","icon_powerplug"],
    ["salzlecke", 'icon-salzlecke'],
    ["schoepfstelle","icon_schoepfstelle"],
    ["sammelplatz", "icon_sammelplatz"],
    // ["selectedPoint","icon-pin"],
    ["suhle","icon_suhle"],
    ["tablecells","icon-table"],
    ["tor","icon_tor"],
    ["wasserlitze","icon-wasserlitze"],
    ["wildkamera","icon-wildkamera"],
    ["wildkammer", 'diwima_smp_wildkammer-maj'],

])

export enum EPlannStatus {
    INPLANNING = "inPlanning",
    PENDEXECUTION = "pendingExecution",
    INPROGRESS = "inProgress",
    TESTED = "tested",
    OVERDUE = "overdue",
}

export class PointOfInterest {

    public static className = "PointOfInterest"
    public className = "PointOfInterest"

    public identifier: string|undefined = undefined
    public contextId: string|undefined = undefined
    public contextIds: string[]|undefined = undefined
    public contextIdRights: {[contextId: string]: 'view'|'update'}|undefined = undefined
    public createdOnDeviceName: string|undefined = undefined
    public revision: Number|undefined = undefined
    public area: Number|undefined = undefined
    public length: Number|undefined = undefined
    public createdByUserId: string|undefined = undefined
    public createdByUserDisplayName: string|undefined = undefined
    
    public locationCoordinates: GeoPoint|undefined = undefined
    public locationHeight: Number|undefined = undefined
    public locationHeading: Number|undefined = undefined
    public additionalHeadings: Number[]|undefined = undefined
    
    public type: string|undefined = undefined
    public typeTitle: string|undefined = undefined
    
    public shortName: string|undefined = undefined
    public shortID: string|undefined = undefined

    public comment: string|undefined = undefined
    public commentUsage: string|undefined = undefined
    public commentMaintenance: string|undefined = undefined
    public usageStatus: string|undefined = undefined
    public maxPersonCount: Number|undefined = undefined

    public testIntervalDays: Number|undefined = undefined
    public lastTestDate: Date|undefined = undefined
    public yearOfContruction: Number|undefined = undefined

    public tagid: string|undefined = undefined
    public rfid_uid: string|undefined = undefined
    
    public huntingDistrictId: string|undefined = undefined
    public huntingDistrictName: string|undefined = undefined
    public nextTestDate: Date|undefined = undefined
    creationDate: Date|undefined = undefined
    updateTimestamp: Date|undefined = undefined

    // ??
    public imageCount: number|undefined = undefined
    public pictureURLlinks?:string[]|undefined
    public shootRegions: any[]|undefined = undefined
    public additionalData: any|undefined = undefined
    public externalReference: string|undefined = undefined

    public category: string|undefined = undefined
    public notificationChannel: { email: string; displayName?: string }[]|undefined = undefined
    
    private context: Context|ContextMembership|undefined = undefined
    private contentType?: string|undefined = undefined
    private encodedContent?: string|undefined = undefined
    public fillColor?: string|undefined = undefined
    public borderColor?: string|undefined = undefined
    public lineWidth?: any|undefined = undefined

    public planningStatus?: EPlannStatus|undefined = undefined
    constructor(
        additionalContext?: Context|ContextMembership
    ) {
        this.context = additionalContext
    }

    setFromAny(element: any) {
        const {
            identifier,
            contextId,
            contextIds,
            contextIdRights,
            notificationChannel,
            creationDate,
            updateTimestamp,
            revision, 
            createdByUserId,
            createdByUserDisplayName,
            createdOnDeviceName,
            locationCoordinates,
            shootRegions, 
            additionalData, 
            shortName, 
            shortID,
            type, 
            typeTitle,
            huntingDistrictId,
            huntingDistrictName,
            usageStatus,
            maxPersonCount,
            testIntervalDays,
            lastTestDate,

            comment,
            commentUsage,
            commentMaintenance,
            locationHeight,
            locationHeading,
            yearOfContruction,
            externalReference,
            additionalHeadings,
            tagid,
            rfid_uid,
            contentType,
            encodedContent,
            category,
            lineWidth,
            imageCount,
            pictureURLlinks,
            area,
            length,
            planningStatus,
            nextTestDate
        } = element
        // set title is id ist present?
        if (!typeTitle && this.type) this.typeTitle = this.getTypeTitle()
        this.identifier = identifier ? identifier : this.identifier
        this.contextId = contextId ? contextId : this.contextId
        this.contextIds = contextIds ? contextIds : this.contextIds
        this.contextIdRights = contextIdRights ? contextIdRights : this.contextIdRights
        this.revision = revision ? revision : this.revision
        this.createdByUserId = createdByUserId ? createdByUserId : this.createdByUserId
        this.createdByUserDisplayName = createdByUserDisplayName ? createdByUserDisplayName : this.createdByUserDisplayName
        this.createdOnDeviceName = createdOnDeviceName ? createdOnDeviceName : this.createdOnDeviceName
        this.locationCoordinates = locationCoordinates ? locationCoordinates : this.locationCoordinates
        this.typeTitle = typeTitle ? typeTitle : this.typeTitle
        this.shootRegions = shootRegions ? shootRegions : this.shootRegions
        this.additionalData = additionalData ? additionalData : this.additionalData
        this.shortName = shortName ? shortName : this.shortName
        this.shortID = shortID ? shortID : this.shortID
        this.type = type ? type : this.type
        this.locationHeading = locationHeading ? locationHeading : this.locationHeading
        this.creationDate = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
        this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
        this.usageStatus = usageStatus ? usageStatus : this.usageStatus
        this.maxPersonCount = maxPersonCount ? maxPersonCount : this.maxPersonCount
        this.testIntervalDays = testIntervalDays ? testIntervalDays : this.testIntervalDays
        this.lastTestDate = lastTestDate ? lastTestDate : this.lastTestDate
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName
        this.comment = comment ? comment : this.comment
        this.commentUsage = commentUsage ? commentUsage : this.commentUsage
        this.commentMaintenance = commentMaintenance ? commentMaintenance : this.commentMaintenance
        this.locationHeight = locationHeight ? locationHeight : this.locationHeight
        this.yearOfContruction = yearOfContruction ? yearOfContruction : this.yearOfContruction
        this.externalReference = externalReference ? externalReference : this.externalReference
        this.additionalHeadings = additionalHeadings ? additionalHeadings : this.additionalHeadings
        this.tagid = tagid ? tagid : this.tagid
        this.rfid_uid = rfid_uid ? rfid_uid : this.rfid_uid
        this.category = category ? category : this.category
        this.notificationChannel = notificationChannel ? notificationChannel : this.notificationChannel
        this.contentType = contentType ? contentType : undefined
        this.encodedContent = encodedContent ? encodedContent : undefined
        this.lineWidth = lineWidth ? lineWidth : undefined,
        this.imageCount = imageCount ? imageCount : undefined,
        this.pictureURLlinks = pictureURLlinks ? pictureURLlinks : undefined
        this.area = area ? area : undefined
        this.length = length ? length : undefined
        this.planningStatus = planningStatus ? planningStatus : undefined
        this.nextTestDate = nextTestDate ? nextTestDate : undefined
    }

    getListItemTitle(): string {
        return this.shortName ? this.shortName : "No name configured"
    }

    searchFilter(filter: string): boolean {
        const str = `${this.shortName}${this.typeTitle}${this.type}${this.huntingDistrictName}`.toLowerCase()
        return str.includes(filter)
    }

    getTypeTitle(): string|undefined {
        if (this.typeTitle) return this.typeTitle
        if (!this.context || !this.type) return undefined
        const settingRef = NetworkConstants.SETTING_GEO_TYPE
        const setting = this.context?.settingsMap?.get(settingRef)
        if (!setting) return this.type
        const type = setting.values.find(el => el.identifier == this.type)
        if (!type) return this.type
        return type.title
    }

    getIconName(): string|undefined {
        if (!this.type) return undefined
        return DefaultIconsPoiMapping.get(this.type)// ?? DefaultIconsPoiMapping.get('pin')
    }

    getFeature(strUnkown: string,iconName:string): any|undefined {
        const location = this.locationCoordinates
        if (!location) return undefined
        let {
            identifier, 
            shortName, 
            type, 
            // typeTitle, 
            usageStatus,
            creationDate,
            maxPersonCount
        } = this
        let icon = DefaultIconsPoiMapping.get(iconName)
        // let icon: string|undefined = this.getIconName()
        let typeTitle = this.getTypeTitle()
        if (!icon) {
            icon = DefaultIconsPoiMapping.get('pin')
        }
        return {
            type: "Feature",
            properties: {
                identifier,
                shortName,
                icon,
                type,
                typeTitle: typeTitle ? typeTitle : strUnkown,
                creationDate,
                usageStatus,
                maxPersonCount,
            },
            geometry: {
            type: 'Point',
            coordinates: [location.longitude, location.latitude]
            }
        }
    }


    getFeatures(){
        let features = []
        var geometry : GeoJSON.Geometry = { type : 'Polygon', coordinates: []}

        if(this.encodedContent){
            var properties:GeoJSON.GeoJsonProperties = {}
            const encodedContent = this.encodedContent.split(" ")
            let pairs
            pairs = encodedContent.reduce(function(result:any, value, indexV, array) {
              if (indexV % 2 === 0){
                const splited = array.slice(indexV, indexV + 2)
                var lat: number = +splited[1];
                var lng: number = +splited[0];
                const valueLatLng =[ lat, lng ]
                result.push(valueLatLng);
              }
              return result;
            }, []);

            if(this.contentType == 'polygon'){
              geometry = {
                type: 'MultiPolygon',
                coordinates: [[pairs]]
              };
            }

            if(this.contentType == 'line'){
              geometry = {
                type: 'MultiLineString',
                coordinates: [pairs]
              };
            }

            var feature: GeoJSON.Feature = {
                type: "Feature",
                geometry: geometry,
                id:this.identifier,
                properties:properties,
            }
          features.push(feature)
        }
        return features
    }

    getGeoJsonFromFeatures(features:any): any|undefined {
        if (!features) return undefined
        const geoJsonBase = {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features':features
            }
        }
        return geoJsonBase
    }

    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key 
     */
     replacerFn(key: string) {
        const list = ["context", "className"]
        if (list.includes(key)) return false
        else return true
    }
}